import { render } from "./ReviewAnswers.vue?vue&type=template&id=5007e3e0&scoped=true&ts=true"
import script from "./ReviewAnswers.vue?vue&type=script&lang=ts"
export * from "./ReviewAnswers.vue?vue&type=script&lang=ts"

import "./ReviewAnswers.vue?vue&type=style&index=0&id=5007e3e0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5007e3e0"]])

export default __exports__